import { saveAs } from 'file-saver'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

//UI
import { Button, Flex, Heading, Spacer, Text } from '@chakra-ui/react'
import { toast } from 'react-toastify'

import useOfferApproval from '@/features/offers/hooks/useOfferApproval'
import useOfferList from '@/features/offers/hooks/useOfferList'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { createExcelBlob } from '@/utils/fileHelper'
import { useQueryClient } from '@tanstack/react-query'

const OfferApprovalListHeader = ({ offerCount = 0, selectedApprovals = [], resetSelection }) => {
  const [createOfferBatchUpdateModalDetail, setCreateOfferBatchUpdateModalDetail] = useState({
    show: false,
  })

  const { useFetchOfferApprovals } = useOfferList()
  const { useBatchApprove } = useOfferApproval()
  const { data: allOfferApprovalResponse } = useFetchOfferApprovals({ page: 1, pageSize: 0 })

  const dispatch = useDispatch()
  const batchApprove = useBatchApprove()
  const queryClient = useQueryClient()

  const handleDownload = () => {
    if (!allOfferApprovalResponse?.data) return
    try {
      const excelData = allOfferApprovalResponse.data
      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, 'Offer Approvals.xlsx')
    } catch (err) {
      console.log(err)
    }
  }

  const handleBatchApprove = async () => {
    if (selectedApprovals.length === 0) {
      toast.error('You have not select any valid approvals.')
      return
    }

    try {
      dispatch(showLoadingOverlay)

      const batchApprovalResult = await batchApprove.mutateAsync(selectedApprovals)
      queryClient.invalidateQueries(['offers', 'list', 'approvals'])

      if (Array.isArray(batchApprovalResult)) {
        if (batchApprovalResult.some((result) => !result.success)) {
          toast.error(
            <Flex direction={'column'}>
              {batchApprovalResult.map((result, index) => (
                <Text key={index}>{`[${index + 1}/${batchApprovalResult.length}] ${result.remark}`}</Text>
              ))}
            </Flex>
          )
          return
        }
        toast.success(
          <Flex direction={'column'}>
            {batchApprovalResult.map((result, index) => (
              <Text key={index}>{`[${index + 1}/${batchApprovalResult.length}] ${result.remark}`}</Text>
            ))}
          </Flex>
        )
      }
    } catch (err) {
      console.log(err)
    } finally {
      resetSelection()

      dispatch(hideLoadingOverlay)
    }
  }

  return (
    <>
      <Flex p={5} borderBottom="1px solid #d8dbe0">
        <Heading>Approvals ({offerCount})</Heading>
        <Spacer />

        <Flex gap={1} alignItems={'center'}>
          <Button colorScheme={'green'} onClick={handleDownload}>
            Download
          </Button>
          <Button colorScheme={'blue'} onClick={handleBatchApprove}>
            Batch Approve
          </Button>
        </Flex>
      </Flex>
    </>
  )
}

export default OfferApprovalListHeader
